import { withAsyncBoundary } from '@toss/async-boundary';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button } from '@zep/ui';
import { useBusinessPaymentResult } from '../../../services';
import { BusinessPaymentLayout } from './BusinessPaymentLayout';
import { BusinessPaymentInvalidPage } from './BusinessPayments';
import S from './BusinessPayments.module.scss';
const BusinessPaymentsFailInner = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['business']);
  const paymentHashId = (router.query.id ?? '').toString();
  const email = (router.query.email ?? '').toString();
  const {
    data: {
      businessPayment
    }
  } = useBusinessPaymentResult({
    paymentHashId,
    email
  });
  return <BusinessPaymentLayout title={businessPayment.customerName} data-sentry-element="BusinessPaymentLayout" data-sentry-component="BusinessPaymentsFailInner" data-sentry-source-file="BusinessPaymentsFail.tsx">
      <div className={S.payments_result_section}>
        <h2 className={S.payments_result_title}>
          {t('business:business_payments_failure')}
        </h2>
        <div>
          {t('business:business_payments_failure_content1', {
          name: businessPayment.customerName
        })}
        </div>
        <div>{t('business:business_payments_failure_content2')}</div>
      </div>
      <Button className={S.retry_button} size="lg" onClick={() => router.replace(`/business/payments/${paymentHashId}`)} data-sentry-element="Button" data-sentry-source-file="BusinessPaymentsFail.tsx">
        {t('business:business_payments_retry_button')}
      </Button>
    </BusinessPaymentLayout>;
};
export const BusinessPaymentsFail = withAsyncBoundary(BusinessPaymentsFailInner, {
  pendingFallback: '',
  rejectedFallback: () => <BusinessPaymentInvalidPage />
});